import React from 'react';
import './StudentVisum.css';

class StudentVisum extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-100-m w-100-l mw6 shadow-5 center">
                    <main className="pa2 black-80">
                        <div className="measure">
                            <fieldset id="sign_up" className="ba b--transparent ph0 mh0 rgt">
                                <legend className="legend f1 fw6 ph0 mh0">فيزا الدراسة</legend>

                                <div className="ui form mt4">
                                    <div className="fields">
                                        <div className="field rgt">
                                            <p>
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/requirements'>
                                                        ايه المطلوب للدراسة
                                                    </a>
                                                </h1>
                                               
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/interview'>
                                                        الاوراق المطلوبة فى مقابلة السفارة بغرض الدراسة
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/basic_docs'>
                                                        الأوراق الأساسية للدراسة و توثيق الأوراق من السفارة الألمانية
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/daad'>
                                                        شرح إستخدام موقع الدااد و البحث عن الجامعات ولغة الدراسة وطريقة مراسلة الجامعة
                                                    </a>
                                                </h1>

                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/highschool'>
                                                        شهادتك في الثانوية هتدرس بيها أيه
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/prepyear'>
                                                        السنة التحضيرية: شروط طلاب الثانوية العامة و الدبلومة الامريكية و الثانوية البريطانية
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/recognization'>
                                                        ازاى تعرف جامعتك معترفة في ألمانيا
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/apply'>
                                                        مواعيد و كيفية التقديم على الجامعة و ما هو القبول المشروط والنهائى ؟
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/togermanscore'>
                                                        ازاى تحول تقديرك للتقدير الألماني
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/acceptance_types'>
                                                        ما هو القبول المقيد و المفتوح في ألمانيا و ما نسبة قبولى في الجامعة
                                                    </a>
                                                </h1>
                                                
                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/medicine'>
                                                        دراسة المجال الطبي و استكماله في المانيا
                                                    </a>
                                                </h1>

                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/complete_uni'>
                                                        معادلة المواد و استكمال الدراسة فى المانيا
                                                    </a>
                                                </h1>

                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/uni_types'>
                                                        ما هو الفرق بين انواع الجامعات الألمانية .. النظرية و العملية ؟
                                                    </a>
                                                </h1>

                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/bestunis'>
                                                        كيفية معرفة افضل الجامعات فى المانيا
                                                    </a>
                                                </h1>

                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/timeplan'>
                                                        معلومات عن الخطة الزمنية للدراسة فى المانيا - الحساب البنكى و تجديده
                                                    </a>
                                                </h1>

                                                <hr/>
                                                <h1>
                                                    <a href='/studentvisum/rejectreasons'>
                                                        أسباب رفض فيزا الدراسة و طريقة التظلم
                                                    </a>
                                                </h1>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </main>
            </article>
        );
    }
}

export default StudentVisum;
